import { TranslationsData } from '../models';
import { store } from './store';

interface Urls {
  api: string;
}

/** Reference used to store urls */
export const urls: Urls = {
  api: '',
};

/**
 * Sets the urls object to be ready for services
 * - config: object - The environment config
 */
export const setUrls = (config: Partial<Urls>) => {
  const { api } = config;

  Object.assign(urls, {
    api,
  });
};

export const convertMgToMmol = (value: string | number) =>
  Number((Number(value) / 18).toFixed(1));
export const convertMmolToMg = (value: string | number) =>
  Number((Number(value) * 18).toFixed(0));

/**
 * Will get the `key` from the `trans` data from the partner data. returns empty string if one isn't found
 * using the `langFallBack` from config
 * @param trans The partner configuration for tanslations
 */
export const getTranslation = (
  trans: TranslationsData,
  key: string,
): string => {
  if (trans === null) {
    return '';
  }

  const lang = store ? store.getState().user.language || 'en-GB' : 'en-GB';
  // This should be the configurable list of supported languages
  const { langFallBack = { default: ['en-US'] } } = store
    ? store.getState().config
    : {};
  let fallbacks = langFallBack[lang] || [];
  const langs = lang ? [lang] : [];

  // Add 2 char fallbacks after 5 char fallbacks
  fallbacks = fallbacks.concat(langFallBack[lang.substr(0, 2)] || []);

  const fullList = [
    ...new Set([...langs, ...fallbacks, ...langFallBack['default'], 'default']),
  ];

  for (const l of fullList) {
    if (trans.languages[l]) {
      if (trans.languages[l][key]) {
        return trans.languages[l][key];
      }
    }
  }

  return '';
};
